<app-modal-window title="История блокировок" (close)="close()">
  <div class="lock-history-modal">
    <table border="1" cellspacing="0" cellpadding="8" style="width: 100%; border-collapse: collapse;">
      <thead>
      <tr>
        <th>Дата</th>
        <th>Тип</th>
        <th>Действие</th>
        <th>Кто</th>
        <th>Источник</th>
        <th>Причина</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let h of history">
        <td>{{ h.createdAt | date: 'dd.MM.yy HH:mm' }}</td>
        <td>{{ h.type }}</td>
        <td [style.color]="h.action === LockActionEnum.LOCK ? 'red' : 'green'">
          {{ h.action === LockActionEnum.LOCK ? 'Блокировка' : 'Снятие' }}
        </td>
        <td>
          <ng-container *ngIf="h.actorType === 'admin' && h.actorId; else plainActor">
            Админ <a [routerLink]="['/user/', h.actorId]" (click)="close()">#{{ h.actorId }}</a>
          </ng-container>
          <ng-template #plainActor>{{ formatActor(h.actorType, h.actorId) }}</ng-template>
        </td>
        <td>{{ h.source || '-' }}</td>
        <td>{{ h.reason || '-' }}</td>
      </tr>
      <tr *ngIf="!loading && !history.length">
        <td colspan="6" style="text-align: center;">Нет записей</td>
      </tr>
      </tbody>
    </table>

    <div class="lock-history-modal__pager" *ngIf="totalPages > 1">
      <button class="btn btn-sm"
              [disabled]="page <= 1 || loading"
              (click)="loadPage(page - 1)">←</button>
      <span>Стр. {{ page }} из {{ totalPages }} (всего {{ total }})</span>
      <button class="btn btn-sm"
              [disabled]="page >= totalPages || loading"
              (click)="loadPage(page + 1)">→</button>
    </div>
  </div>
</app-modal-window>
